import { getApiBaseUrl, getStoredToken, safeApiRequest } from './apiClient';
import { getCsrfToken } from './authService';

const ADMIN_FILES_ENDPOINT = '/api/admin/files';

/**
 * Admin dosyalarını listele
 */
export const fetchAdminFiles = async () => {
  return safeApiRequest(ADMIN_FILES_ENDPOINT, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Dosya yükle
 * @param {File} file - Yüklenecek dosya
 */
export const uploadAdminFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const headers = {};
  try {
    const csrfToken = await getCsrfToken();
    if (csrfToken) headers['X-CSRF-Token'] = csrfToken;
  } catch {
    // CSRF alınamazsa devam et
  }

  const response = await fetch(`${getApiBaseUrl()}${ADMIN_FILES_ENDPOINT}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getStoredToken()}`,
      ...headers,
    },
    body: formData,
    credentials: 'include',
  });

  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(json?.mesaj || 'Dosya yüklenemedi');
    err.status = response.status;
    err.data = json;
    throw err;
  }
  return json;
};

/**
 * Dosya indir — R2: API auth sonrası presigned URL ile doğrudan Cloudflare'den iner.
 * Eski yerel dosyalar sunucu akışından blob olarak indirilir.
 * @param {string} id - Dosya ID
 * @param {string} filename - İndirilecek dosya adı (orijinal dosya adı)
 */
export const downloadAdminFile = async (id, filename) => {
  const token = getStoredToken();
  const response = await fetch(`${getApiBaseUrl()}${ADMIN_FILES_ENDPOINT}/${id}/download`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    credentials: 'include',
  });

  if (!response.ok) {
    const json = await response.json().catch(() => ({}));
    const err = new Error(json?.mesaj || 'Dosya indirilemedi');
    err.status = response.status;
    throw err;
  }

  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    const json = await response.json();
    const directUrl = json?.veri?.url;
    if (!directUrl) {
      throw new Error('İndirme bağlantısı alınamadı');
    }
    // Cross-origin presigned URL: download attribute çalışmaz (mobil dahil).
    // Tarayıcıyı doğrudan R2'ye yönlendir; Content-Disposition ile dosya iner.
    window.location.assign(directUrl);
    return;
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

/**
 * Dosya sil
 * @param {string} id - Dosya ID
 */
export const deleteAdminFile = async (id) => {
  return safeApiRequest(`${ADMIN_FILES_ENDPOINT}/${id}`, {
    method: 'DELETE',
    skipCsrf: false,
  });
};

/**
 * Dosyayı yayınla
 * @param {string} id - Dosya ID
 */
export const publishAdminFile = async (id) => {
  return safeApiRequest(`${ADMIN_FILES_ENDPOINT}/${id}/publish`, {
    method: 'POST',
    skipCsrf: false,
  });
};

/**
 * Dosyayı yayından kaldır
 * @param {string} id - Dosya ID
 */
export const unpublishAdminFile = async (id) => {
  return safeApiRequest(`${ADMIN_FILES_ENDPOINT}/${id}/publish`, {
    method: 'DELETE',
    skipCsrf: false,
  });
};
